/**
 * Path helpers for the Transparent conversion — a LEAF module on purpose.
 *
 * It imports nothing: no canvas, no `PlatformIO`, no `keying.ts`. That is what lets
 * `queue/manager.ts` derive a transparent item's key from the SAME function `run.ts` uses to
 * name its rows, without the queue gaining a DOM dependency (WS-N's `runTransparent` port
 * exists precisely so it does not). One implementation, so a file cannot be keyed under one
 * path in the checkpoint and reported under another in the row.
 */

/** Only these extensions are converted. Applied by the caller before building a run spec. */
export const IMAGE_RE = /\.(png|jpe?g|webp)$/i;

/**
 * The relative path a converted file is filed under: the source path with any leading
 * `magenta…` source folder stripped. Moved verbatim from `TransparentPanel`'s loop.
 */
export function relPathOf(f: { name: string; path?: string }): string {
  return (f.path ?? f.name).replace(/^.*?magenta[^/]*\//i, "").replace(/^\//, "");
}
